import React from 'react';
import { Radio, RadioGroup, FormControl, FormControlLabel, FormLabel } from '@material-ui/core/';
import { FeaturePermissionEntityInterface, PagePermissionEntityInterface } from '@types';
import { useDispatch } from 'react-redux';
import './index.scss';
import { setCurrentRolePageFeatureActionPermission } from '@actions/roleActions';

interface Props {
  pagePermission: PagePermissionEntityInterface;
  feature: FeaturePermissionEntityInterface;
  action: string;
}

const ConfigurationRadioGroup = ({ pagePermission, feature, action }: Props) => {
  const value = feature[action];
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const nextValue = event.target.value === 'true';
    dispatch(
      setCurrentRolePageFeatureActionPermission(pagePermission.id, feature.id, action, nextValue)
    );
  };

  return (
    <FormControl
      component="fieldset"
      className="feature-configuration-action"
      data-testid="feature-configuration-action"
    >
      <FormLabel component="legend">{action}</FormLabel>
      <FormControl component="fieldset">
        <RadioGroup aria-label="configuration" name="gender1" value={value} onChange={handleChange}>
          <FormControlLabel value={true} control={<Radio />} label="allow" />
          <FormControlLabel value={false} control={<Radio />} label="disallow" />
        </RadioGroup>
      </FormControl>
    </FormControl>
  );
};

export { ConfigurationRadioGroup };
